import { deleteRequest, get, patch, post } from "./api";

export const listCustomerScenarios = (customerId, params = {}, signal = null) => {
  const url = `/api/v2/customers/${customerId}/scenarios/`;
  return get(url, params, false, signal, true);
};

export const createCustomerScenario = (customerId, payload, signal = null) => {
  const url = `/api/v2/customers/${customerId}/scenarios/`;
  return post(url, payload, { signal });
};

export const getCustomerScenario = (customerId, scenarioId, params = {}, signal = null) => {
  const url = `/api/v2/customers/${customerId}/scenarios/${scenarioId}/`;
  return get(url, params, false, signal, true);
};

export const updateCustomerScenario = (customerId, scenarioId, payload, signal = null) => {
  const url = `/api/v2/customers/${customerId}/scenarios/${scenarioId}/`;
  return patch(url, payload, { signal });
};

export const deleteCustomerScenario = (customerId, scenarioId) => {
  const url = `/api/v2/customers/${customerId}/scenarios/${scenarioId}/`;
  return deleteRequest(url);
};

